import type { PaymentMethod } from '@lt/api/dist/methods/orders/types/paymentMethods';
import { useTranslation } from '@lt/localization';
import cn from 'classnames';
import React from 'react';
import {
  PAYLATE_WARNING,
  PAYLATE_WARNING_AMOUNT,
} from 'src/store/payment/constants';
import styles from './paylatePayment.module.css';

interface PaylatePaymentProps {
  amount: number;
  additionalData?: Extract<
    PaymentMethod,
    { type: 'paylate' | 'paylate_120' }
  >['additionalData'];
}

const PaylatePayment = (props: PaylatePaymentProps) => {
  const { t } = useTranslation();
  const { amount, additionalData } = props;

  if (Array.isArray(additionalData)) return null;
  const { payToday, percent, period, info } = additionalData || {};
  if (!payToday || !percent || !period) return null;

  return (
    <div>
      {amount > PAYLATE_WARNING_AMOUNT && (
        <div className={styles.warning}>{PAYLATE_WARNING}</div>
      )}

      {[payToday, percent, period].map(({ title, description }) => (
        <div className={styles.row} key={null}>
          <span className={styles.title}>{title}</span>

          <span className={styles.description}>{description}</span>
        </div>
      ))}

      <div
        className={styles.additional}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: info?.description ?? '' }}
      />
      <a
        className={styles.link}
        title={t('checkout.payment.detail')}
        href="//promo.level.travel/paylate"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('checkout.payment.detail')}
      </a>
      <div className={cn(styles.sub, styles.payment)}>
        {t('checkout.payment.paylate')}
        <div className={styles.icon} />
      </div>
    </div>
  );
};

export default PaylatePayment;
